// extracted by mini-css-extract-plugin
export default {"JobDetails":"JobDetails_JobDetails__dT9GD","JobDetails__tag":"JobDetails_JobDetails__tag__eYDEO","tag":"JobDetails_tag__O2BzW","editIcon":"JobDetails_editIcon__wYSkg"};